import { jsx } from "react/jsx-runtime";
import { LogoIcon } from "@tamagui/logo";
import { Square } from "tamagui";
function AnimationsTimingDemo() {
  return /* @__PURE__ */ jsx(
    Square,
    {
      backgroundColor: "$pink10",
      animation: "100ms",
      elevation: "$4",
      size: 110,
      borderRadius: "$9",
      hoverStyle: {
        scale: 1.2
      },
      pressStyle: {
        scale: 0.9
      },
      children: /* @__PURE__ */ jsx(LogoIcon, { downscale: 0.75 })
    }
  );
}
export {
  AnimationsTimingDemo
};
//# sourceMappingURL=AnimationsTimingDemo.js.map
